import {useEffect, useState} from 'react';

const defaultWindowSize = {
  width: 0,
  height: 0,
  isMobile: false,
};

const getWindowSize = () => {
  if (typeof window !== 'undefined') {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      isMobile: window.innerWidth <= 767,
    };
  }

  return defaultWindowSize;
}

export const useDimensions = () => {

  const [windowSize, setWindowSize] = useState(defaultWindowSize);

	const changeWindowSize = () => {
    setWindowSize(getWindowSize());
  };

  

	useEffect(() => {
    changeWindowSize();
    window.addEventListener(`resize`, changeWindowSize, {passive: true});

    return () => {
      window.removeEventListener(`resize`, changeWindowSize);
    };
  }, []);
	
	return windowSize;
};
